import { lazy } from "react";

const ContactTable = lazy(() => import("./ContactTable"));
const ContactList = lazy(() => import("./ContactList"));
const ContactDetails = lazy(() => import("./ContactDetails"));
const ContactEditor = lazy(() => import("./ContactEditor"));
const ContactEditor2 = lazy(() => import("../../Employees/EmployeForm"));

const contactRoutes = [
  { path: "/contact/table", element: <ContactTable /> },
  { path: "/contact/list", element: <ContactList /> },
  { path: "/contact/details", element: <ContactDetails /> },
  { path: "/contact/create", element: <ContactEditor /> },
  { path: "/contact/edit", element: <ContactEditor2 /> }

];

export default contactRoutes;
